import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InfoModalOnboarding } from '../info-modal/info-modal';
import { ConfirmDialog } from 'src/app/layout/dialog.component';
import { Router } from '@angular/router';
import { SettingsService } from 'src/app/settings/settings.service';

@Component({
  selector: 'app-revision-contrato',
  standalone: false,
  templateUrl: './revision-contrato.component.html',
  styleUrl: './revision-contrato.component.less'
})
export class RevisionContratoComponent implements OnInit{
  @Input() initialStep: number = 1;

  step: any = 1;
  stepper_aval: any = 1;

  avales = [
    { 
      id: 1,
      nombre: "Juan", 
      apellidos: "Delgado Santander", 
      telefono: "933880659", 
      email: "juan.delgado@santamaria.cl" 
    },
    { 
      id: 2,
      nombre: "Ana", 
      apellidos: "Arellano", 
      telefono: "950230640", 
      email: "ana.arellano@santamaria.cl" 
    },
  ];

  firmantes = [
    { 
      id: 1,
      nombre: "Juan", 
      apellido: "Delgado", 
      telefono: "", 
      email: "",
       rol: "titular"
    },
    { 
      id: 2,
      nombre: "Ana", 
      apellido: "Arellano", 
      telefono: "", 
      email: "",
      rol: "conyuge"
    },
  ];

  constructor(
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private settings: SettingsService
  ) {}

  nombreCompletoTitular: string = '';
  is_responsive: boolean = false;
  ngOnInit() {
    this.step = this.initialStep;

    const titular = this.firmantes.find(f => f.rol === 'titular');
    if (titular) {
      this.nombreCompletoTitular = `${titular.nombre} ${titular.apellido}`;
    }

  }



  open_modal_info(step: any) {

    let dialogRef = this.dialog.open(InfoModalOnboarding, {
      width: '700px',
      autoFocus: false,
    });

    dialogRef.componentInstance.step = step;

    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if(result == 'continue_revision'){
        this.step = 1;
        this.stepper_aval = 3;
      }
    });
    
  }

  coninuar_stepper2(){
    this.stepper_aval = 2;
    
    let dialogRef = this.dialog.open(InfoModalOnboarding, {
      width: '700px',
      autoFocus: false,
    });
  
    dialogRef.componentInstance.step = 28;
    dialogRef.componentInstance.avalEmail = this.avales.length > 0 ? this.avales[0].email : '';

    console.log('Email en modal:', dialogRef.componentInstance.avalEmail);
  }
  
  ingresar_datos(aval_id: any){
    const firmanteEditar = this.firmantes.find(aval => aval.id === aval_id);
  
    if (!firmanteEditar) {
      console.error('Aval no encontrado con ID:', aval_id);
      return;
    }

    let dialogRef = this.dialog.open(InfoModalOnboarding, {
      width: '700px',
      autoFocus: false,
    });
  
    dialogRef.componentInstance.step = 29;
    dialogRef.componentInstance.firmanteEditar = firmanteEditar;
    dialogRef.componentInstance.firmanteName = firmanteEditar.nombre + ' ' + firmanteEditar.apellido;

    

    console.log('ID de aval:', dialogRef.componentInstance.firmanteEditar);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.updated) {
        const index = this.firmantes.findIndex(f => f.id === aval_id);
        if (index !== -1) {
          this.firmantes[index] = result.firmante;
          console.log('Firmante actualizado:', this.firmantes[index]);
          
          this.cdr.detectChanges();
        }
      }
    });
  }
  

  selectedOption: string = '';
  logout() {
    let dialogRef = this.dialog.open(ConfirmDialog, {
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result:any) => {
      this.selectedOption = result;

      if (this.selectedOption == 'Y') {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('device_token')
        this.router.navigateByUrl('/login');
      }
    });
  }

}
